import { Component, OnInit } from "@angular/core";
import { PoPageChangePasswordRequirement } from "@po-ui/ng-templates";
import { environment } from "../../../environments/environment";

@Component({
    selector: 'erpcloud-password-recovery',
    templateUrl: './password-recovery.component.html',
    styleUrls: ['./password-recovery.component.css'],
    standalone: false
})
export class PasswordRecoveryComponent implements OnInit {

    poPageChangePasswordRequirement: PoPageChangePasswordRequirement[] = [];
    readonly serviceApi = `${environment.apiUrl}/v1/security/password-reset`;
    constructor() {
        this.poPageChangePasswordRequirement = [
            {
                requirement: 'Mínimo 8 caracteres',
                status: (pass: string) => { return pass?.length >= 8 },
            },
            {
                requirement: 'Mínimo 1 letra maiúscula',
                status: (pass: string) => { return RegExp(/[A-Z]/).exec(pass) },
            },
            {
                requirement: 'Mínimo 1 letra minúscula',
                status: (pass: string) => { return RegExp(/[a-z]/).exec(pass) },
            },
            {
                requirement: 'Mínimo 1 número',
                status: (pass: string) => { return RegExp(/\d/).exec(pass) },
            }
        ];
    }
    ngOnInit(): void {

    }



}
